import {
    PROCESS_BEGIN,
    PROCESS_SUCCESS,
    PROCESS_FAILURE,
    CLEAR_PROCESS,

    PROCESS_FILTERS_SUCCESS,
    PROCESS_FILTERS_BEGIN,
    PROCESS_FILTERS_FAILURE,
    CLEAR_PROCESS_FILTERS
} from 'app/actions/ProcessActions';

const initialState = {
    data: [],
    filters: [],
    isLoading: false,
};

export default function ProcessReducer(state = initialState, action) {
    switch (action.type) {
        case PROCESS_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case PROCESS_SUCCESS:
            let data = action.payload.data.Data
            
            return {
                ...state,
                data,
                isLoading: false,
            };
        case PROCESS_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case PROCESS_FILTERS_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case CLEAR_PROCESS:
            return {
                ...state,
                data: [],
                isLoading: false,
            }
        case PROCESS_FILTERS_SUCCESS:
            let filters = [...new Set(state.filters.concat(action.payload.data))];
            
            return {
                ...state,
                filters,
                isLoading: false,
            };
        case PROCESS_FILTERS_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case CLEAR_PROCESS_FILTERS:
            return {
                ...state,
                filters: [],
                isLoading: false,
            }
        default:
            return state;
    }
};

export const getProcess = state => {
    return state.data.map(i => Object.assign(i, { TotalRows: state.TotalRows }))
}
export const getIsLoadingProcess = state => {
    return state.isLoading;
}
export const getProcessFilters = state => {
    return state.filters;
}
export const getIsLoadingProcessFilters = state => {
    return state.isLoading;
}